document.addEventListener('DOMContentLoaded', () => {
  const starsContainers = document.querySelectorAll('.Custom-reviews .stars');

  if (!starsContainers.length) return; // 👈 agar element nahi hai toh yahin ruk jao

  starsContainers.forEach(starsContainer => {
    const rating = parseFloat(starsContainer.dataset.rating);
    const stars = starsContainer.querySelectorAll('.star');

    stars.forEach((star, index) => {
      star.classList.remove('full', 'half');

      if (rating >= index + 1) {
        star.classList.add('full');
      } else if (rating >= index + 0.5) {
        star.classList.add('half');
      }
    });
  });
});
